import { createAsyncThunk } from "@reduxjs/toolkit";
import { BuscaDetalhesResultadoSorteioModel } from "../models/resultadoSorteio/buscaDetalheResultadoSorteioModel";
import { ResultadoSorteioDadosModel } from "../models/resultadoSorteio/resultadoSorteioDadosModel";
import { setLoading } from "../redux/slices/configuracoes/configuracoesSlice";
import { setModalReiniciarResultadoSorteio } from "../redux/slices/resultadoSorteio/resultadoSorteioSlice";
import api from "../util/api";
import { toastError, toastSucess } from "../util/toast";

export const calcularDados = createAsyncThunk("/ResultadoSorteio/CalcularDados", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.post("/ResultadoSorteio/CalcularDados", payload.value);
    toastSucess("Resultado calculado com sucesso");
    dispatch(setLoading(false));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const reiniciarResultado = createAsyncThunk("/ResultadoSorteio/ReiniciarResultado", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.post("/ResultadoSorteio/ReiniciarResultado?idSorteio=" + payload.value);
    toastSucess("O resultado do sorteio foi reiniciado com sucesso");
    dispatch(setModalReiniciarResultadoSorteio(false));
    dispatch(setLoading(false));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const carregarDados = createAsyncThunk("/ResultadoSorteio/CarregarDados", async (args: ResultadoSorteioDadosModel) => {
  try {
    const data = await api.get("/ResultadoSorteio/CarregarDados", {
      params: args,
    });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const listarResumo = createAsyncThunk("/ResultadoSorteio/ListarResumo", async (args: ResultadoSorteioDadosModel) => {
  try {
    const data = await api.get("/ResultadoSorteio/ListarResumo", {
      params: args,
    });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const buscarResultadoSorteio = createAsyncThunk("/ResultadoSorteio/BuscarResultadoSorteio", async (idSorteio: number | null) => {
  try {
    const data = await api.get("/ResultadoSorteio/BuscarResultadoSorteio", {
      params: { idSorteio: idSorteio },
    });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const detalhaResultadoSorteio = createAsyncThunk("/ResultadoSorteio/DetalhaResultadoSorteio", async (args: BuscaDetalhesResultadoSorteioModel) => {
  try {
    const data = await api.get("/ResultadoSorteio/DetalhaResultadoSorteio", {
      params: args,
    });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const listarStatusResultadoSorteio = createAsyncThunk("/ResultadoSorteio/ListarStatusResultadoSorteio", async () => {
  try {
    const data = await api.get("/ResultadoSorteio/ListarStatusResultadoSorteio");
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const atualizarResultadoSorteioStatus = createAsyncThunk("/ResultadoSorteio/AtualizarResultadoSorteioStatus", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/ResultadoSorteio/AtualizarResultadoSorteioStatus", null, { params: payload.value });
    toastSucess("Status do resultado foi atualizado com sucesso");
    dispatch(setLoading(false));

    dispatch(buscarResultadoSorteio(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});
